const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const DamageEvent = require('../../events/DamageEvent');
const { logError } = require('../../logger');

const Lightning = function (battleState) {
  this.handle = 'lightning';
  this.magic = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = (actor, victim) => !!victim.unit;

  this.execute = (actor, victim, isProc = false) => {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      const reflected = BattleCalc.rollForReflectMagic(victim);
      const finalActor = reflected ? victim : actor;
      const finalVictim = reflected ? actor : victim;

      for (const unit of Object.values(battleState.allUnits)) {
        unit.hitByLightning = false;
      }
      finalActor.hitByLightning = true;

      var result = { strikes: [], isProc };
      var damage = isProc
        ? 50 + actor.level * 1.5
        : BattleCalc.getEquippedAbility(actor, 'lightning').damage;
      damage += Math.random() * 13;
      executeAsChain(finalActor, finalVictim, damage, result);

      result.abilityHandle = this.handle;
      result.actorId = finalActor.uid;
      result.victimId = finalVictim.uid;
      result.is_reflection = reflected;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Lightning',
        func: 'execute',
        actor,
        victim,
        isProc,
      });
      return { success: false };
    }
  };

  const executeAsChain = (actor, uVictim, damage, result) => {
    uVictim.hitByLightning = true;

    // if( checkForMagicMirror(actor,uVictim) ) {
    // 	effects( uVictim, actor, damage );
    // } else {
    effects(actor, uVictim, damage, result);
    // }
  };

  const effects = (finalActor, finalVictim, damage, result) => {
    finalVictim.hitByLightning = true;

    result.strikes.push({ actorId: finalActor.uid, victimId: finalVictim.uid });

    var damageEvent = new DamageEvent(battleState, finalActor, damage, this);
    damageEvent.applyStanceAdjustments(finalVictim);

    if (damageEvent.damage >= 5) {
      makeNewLightningEvent(finalVictim, damageEvent.damage, result);
    }

    damageEvent.execute(finalVictim);
  };

  const makeNewLightningEvent = (newActor, oldDamage, result) => {
    var potentialVictims = findVictims(newActor);

    if (potentialVictims.length > 0) {
      var newVictim =
        potentialVictims[Math.floor(Math.random() * potentialVictims.length)];
      executeAsChain(newActor, newVictim, oldDamage / 2, result);
    }
  };

  const findVictims = (newActor) => {
    var potentialVictims = [];
    var dist;
    var adjacentVictim = false;

    for (var prop in battleState.allUnits) {
      var unit = battleState.allUnits[prop];

      dist = BattleCalc.boardDistance(newActor, unit);

      if (
        (dist === 1 || dist === 2) &&
        !unit.hitByLightning &&
        !BattleCalc.tileBetweenThemIsOccupied(newActor, unit, battleState)
      ) {
        potentialVictims.push(unit);

        if (dist === 1) {
          adjacentVictim = true;
        }
      }
    }

    if (adjacentVictim) {
      potentialVictims = BattleCalc.clearDistTwoVictims(
        newActor,
        potentialVictims
      );
    }

    return potentialVictims;
  };
};
module.exports = Lightning;
